import { render, staticRenderFns } from "./orderDetailOrConfirm.vue?vue&type=template&id=93fe1b98&scoped=true"
import script from "./orderDetailOrConfirm.vue?vue&type=script&lang=js"
export * from "./orderDetailOrConfirm.vue?vue&type=script&lang=js"
import style0 from "./orderDetailOrConfirm.vue?vue&type=style&index=0&id=93fe1b98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fe1b98",
  null
  
)

export default component.exports